import React from "react";
import {CaptionStepComponent, FullCaptionComponent} from "../../../../../app/components/caption/CaptionComponent";
import {CodeComponent} from "../../../../../app/components/code/CodeComponent";

export function HashMapRemoveLevelFullCaption() {
    return (<FullCaptionComponent title="VALUE: level">
        <HashMapRemoveLevel1/>
        <HashMapRemoveLevel2/>
        <HashMapRemoveLevel3/>
        <HashMapRemoveLevel4/>
    </FullCaptionComponent>)
}

export function HashMapRemoveLevel1() {
    return (<CaptionStepComponent title={<h6>1. Generate <CodeComponent
        className="codeHash">HASH</CodeComponent>. <CodeComponent>O(1)</CodeComponent></h6>}>
        <p>Unlike inserting, we typically do <i>not</i> call a <CodeComponent>contains</CodeComponent> function. As
            you will see later on, while <CodeComponent>contains</CodeComponent> typically runs
            in <CodeComponent>O(1)</CodeComponent> time, it <i>can</i> be up
            to <CodeComponent>O(n)</CodeComponent> time in our worst case scenario. With inserting, we don't need to
            iterate over our sub-collection, as we are just adding a <CodeComponent
                className="codeValue">VALUE</CodeComponent> to the end.</p>
        <p>However, when <i>removing</i> a <CodeComponent className="codeValue">VALUE</CodeComponent>, we will
            always need to iterate over our sub-collection in order to find the exact <CodeComponent
                className="codeValue">VALUE</CodeComponent> we are looking to remove. Because of this distinction,
            we typically do not call the <CodeComponent>contains</CodeComponent> function when removing
            a <CodeComponent className="codeValue">VALUE</CodeComponent>. While it wouldn't asymptotically change
            the time complexity - <CodeComponent>O(2n)</CodeComponent> still reduces
            to <CodeComponent>O(n)</CodeComponent> - it would still be more time, so we might as well just make
            it <CodeComponent>O(n)</CodeComponent> to begin with.</p>
        <p>Therefore, let's assume that if we input our <CodeComponent className="codeKey">KEY</CodeComponent> of
            "eellv" into our <CodeComponent>generateHash</CodeComponent> function, it will output a <CodeComponent
                className="codeHash">HASH</CodeComponent> of 5.</p>
    </CaptionStepComponent>)
}

export function HashMapRemoveLevel2() {
    return (<CaptionStepComponent title={<h6>2. Find sub-collection at the <CodeComponent
        className="codeHash">HASH</CodeComponent> index. <CodeComponent>O(1)</CodeComponent></h6>}>
        <p>Because our <CodeComponent className="codeHash">HASH</CodeComponent> is 5, we now want to find the
            sub-collection at index 5 of our array.</p>
    </CaptionStepComponent>)
}

export function HashMapRemoveLevel3() {
    return (<CaptionStepComponent title={<h6>3. Iterate over our sub-collection until we found the <CodeComponent
        className="codeValue">VALUE</CodeComponent> we want to
        remove. <CodeComponent><s>O(n)</s></CodeComponent> <CodeComponent>O(1)</CodeComponent></h6>}>
        <p>At <CodeComponent className="codeHash">HASH</CodeComponent> index 5, we only have a single <CodeComponent
            className="codeKey">KEY</CodeComponent> - <CodeComponent
            className="codeValue">VALUE</CodeComponent> object which contains the <CodeComponent
            className="codeValue">VALUE</CodeComponent> we are looking for. While this
            step <i>could</i> be <CodeComponent>O(n)</CodeComponent> time, in this average case, we see the time
            complexity is really only <CodeComponent>O(1)</CodeComponent>.</p>
    </CaptionStepComponent>)
}

export function HashMapRemoveLevel4() {
    return (<CaptionStepComponent title={<h6>4. Remove the corresponding <CodeComponent
        className="codeKey">KEY</CodeComponent> - <CodeComponent
        className="codeValue">VALUE</CodeComponent> object from our
        sub-collection. <CodeComponent>O(1)</CodeComponent>, could also potentially
        be <CodeComponent>O(n)</CodeComponent></h6>}>
        <p>Similarly to <CodeComponent>generateHash</CodeComponent>, we typically do not want to add time complexity
            to this step. In our example, we are using LinkedLists. Which, if we assume are doubly-linked, would
            make the time complexity <CodeComponent>O(1)</CodeComponent> for removing a node from the LinkedList.
            Even if it is singly-linked we would just need to keep track of the previous node to
            ensure <CodeComponent>O(1)</CodeComponent> time complexity as well.</p>
        <p>We remove our <CodeComponent className="codeKey">KEY</CodeComponent> - <CodeComponent
            className="codeValue">VALUE</CodeComponent> object of <CodeComponent>eellv - level</CodeComponent> from
            the sub-collection.</p>
    </CaptionStepComponent>)
}
